var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,31.25C0,33.32,1.68,35,3.75,35h27.5c2.07,0,3.75-1.68,3.75-3.75v-15.63H0v15.63ZM23.87,22.73h6.56v6.56h-6.56v-6.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25,5h-2.5v-2.5c0-1.38-1.12-2.5-2.5-2.5s-2.5,1.12-2.5,2.5v2.5h-12.5v-2.5c0-1.38-1.12-2.5-2.5-2.5s-2.5,1.12-2.5,2.5v2.5h-2.5C1.68,5,0,6.68,0,8.75v3.75h35v-3.75c0-2.07-1.68-3.75-3.75-3.75Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarOn);
export default __webpack_public_path__ + "static/media/calendar_on.c25967e0239abd8ff8cd5e10fc8e4e3f.svg";
export { ForwardRef as ReactComponent };